import React from 'react';
import { Calendar, Clock, Send } from 'lucide-react';

const SchedulerPicker = ({ scheduleMode, setScheduleMode, scheduledDate, setScheduledDate, scheduledTime, setScheduledTime }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <div style={{ display: 'flex', gap: '16px' }}>
        <div 
          onClick={() => setScheduleMode('now')}
          style={{
            flex: 1,
            padding: '20px',
            border: `1px solid ${scheduleMode === 'now' ? 'var(--color-brand-primary)' : 'var(--color-border-primary)'}`,
            borderRadius: '8px',
            cursor: 'pointer',
            background: scheduleMode === 'now' ? 'var(--color-background-info)' : 'var(--color-background-primary)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px',
            transition: 'all 0.2s'
          }}
        >
          <div style={{ 
            background: scheduleMode === 'now' ? 'var(--color-brand-primary)' : 'var(--color-background-tertiary)',
            width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <Send size={20} color={scheduleMode === 'now' ? 'white' : 'var(--color-text-tertiary)'} />
          </div>
          <span style={{ fontWeight: '600', color: scheduleMode === 'now' ? 'var(--color-brand-primary)' : 'var(--color-text-secondary)' }}>
            Send Immediately
          </span>
        </div>
        
        <div 
          onClick={() => setScheduleMode('schedule')}
          style={{
            flex: 1,
            padding: '20px',
            border: `1px solid ${scheduleMode === 'schedule' ? 'var(--color-brand-primary)' : 'var(--color-border-primary)'}`,
            borderRadius: '8px',
            cursor: 'pointer',
            background: scheduleMode === 'schedule' ? 'var(--color-background-info)' : 'var(--color-background-primary)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px',
            transition: 'all 0.2s'
          }}
        >
          <div style={{ 
            background: scheduleMode === 'schedule' ? 'var(--color-brand-primary)' : 'var(--color-background-tertiary)',
            width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <Clock size={20} color={scheduleMode === 'schedule' ? 'white' : 'var(--color-text-tertiary)'} />
          </div>
          <span style={{ fontWeight: '600', color: scheduleMode === 'schedule' ? 'var(--color-brand-primary)' : 'var(--color-text-secondary)' }}>
            Schedule for Later
          </span>
        </div>
      </div>

      {scheduleMode === 'schedule' && (
        <div style={{ 
          background: 'var(--color-background-secondary)', 
          padding: '20px', 
          borderRadius: '8px',
          border: '1px solid var(--color-border-primary)',
          display: 'flex',
          gap: '24px'
        }}>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: '500', fontSize: '14px', color: 'var(--color-text-secondary)' }}>
              <Calendar size={16} /> Date
            </label>
            <input 
              type="date" 
              value={scheduledDate}
              onChange={(e) => setScheduledDate(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid var(--color-border-primary)',
                borderRadius: '6px',
                fontSize: '14px',
                background: 'var(--color-background-primary)'
              }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: '500', fontSize: '14px', color: 'var(--color-text-secondary)' }}>
              <Clock size={16} /> Time
            </label>
            <input 
              type="time" 
              value={scheduledTime}
              onChange={(e) => setScheduledTime(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid var(--color-border-primary)',
                borderRadius: '6px',
                fontSize: '14px',
                background: 'var(--color-background-primary)'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SchedulerPicker;
